import { AdminNavigationIntl } from 'types/i18n';

export const adminNavigationIntl: AdminNavigationIntl = {
  logoHintText: 'Управление\nклиентами',
  clientsGroupText: 'Клиенты',
  productsGroupText: 'Продукты',
  paymentsGroupText: 'Списания и платежи',
  partnersGroupText: 'Партнеры',

  actualClientsLinkText: 'Актуальные',
  archiveClientsLinkText: 'Архив',
  productsLinkText: 'Продукты',
  promocodesLinkText: 'Промокоды',
  subscriptionsLinkText: 'Подписки',
  billsLinkText: 'Списания',
  cardPaymentsLinkText: 'Платежи по карте',
  giroPaymentsLinkText: 'Платежи на р/c',
  actualPartnersLinkText: 'Актуальные',
  dashboardLinkText: 'Мой аккаунт',
  logoutLinkText: 'Выйти',
};
